import { EntityRef } from "utils/rest/entities";
import { MembershipType } from "./membershipType";
import { propertiesOf } from "../utils/propertyOf";

/** Mirrors key2-server's [com.kurzdigital.key2.key2server.dto.RedemptionDto] */
export interface Redemption extends EntityRef {
  id: number;
  code: string;
  lotId: string;
  status: RedemptionStatus;
  membershipType: MembershipType;
  includedCoinAmount: number;
  mintAddress: string;
  serial: number;
  createdAt: string;
  qrCodeUrl: string;
  maxRedemptions: number | null;
  redemptionCount: number;
}

export enum RedemptionStatus {
  VALID = "VALID",
  REDEEMED = "REDEEMED",
}

export interface CreateRedemptionsRequest {
  membershipTypeId: number | null;
  numberOfCodes: number;
  includedCoinAmount?: number;
  customizeCoinAmount: boolean;
  maxRedemptionsPerCode: number | null;
}

export const defaultRedemptionsRequest: CreateRedemptionsRequest = {
  membershipTypeId: null,
  numberOfCodes: 1,
  includedCoinAmount: 0,
  customizeCoinAmount: false,
  maxRedemptionsPerCode: 1,
};

export const ofCreateRedemption = propertiesOf<CreateRedemptionsRequest>();
export const ofRedemption = propertiesOf<Redemption>();
